import React, { useEffect, createElement } from 'react';
import { HeroSection } from '../components/HeroSection';
import { SituationsSection } from '../components/SituationsSection';
import { PainSection } from '../components/PainSection';
import { SolutionSection } from '../components/SolutionSection';
import { CharactersSection } from '../components/CharactersSection';
import { MechanismSection } from '../components/MechanismSection';
import { FeaturesSection } from '../components/FeaturesSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { PackSection } from '../components/PackSection';
import { PricingSection } from '../components/PricingSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';
import { FAQSection } from '../components/FAQSection';
import { ImaginateSection } from '../components/ImaginateSection';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  useEffect(() => {
    // Set page title
    document.title = 'Recetas Mágicas para Niños que Odian las Verduras | Cocina Simple Ya!';
    // Helper to set or create meta tags
    const setMeta = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    const setMetaName = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };
    // Open Graph tags
    setMeta('og:title', 'Recetas Mágicas para Niños que Odian las Verduras');
    setMeta('og:description', '¿Tu hijo se niega a probar verduras? Con nuestras recetas, vas a ver platos vacíos y escuchar "¡Quiero más!" en solo 15 minutos. 65% OFF + 5 bonos gratis.');
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/rueyTBTWirX8tFBqKabGa7/chicosllorandoheylloyd-image-1771674483003.png');
    setMeta('og:type', 'website');
    setMeta('og:locale', 'es_AR');
    // Twitter Card tags
    setMetaName('twitter:card', 'summary_large_image');
    setMetaName('twitter:title', 'Recetas Mágicas para Niños que Odian las Verduras');
    setMetaName('twitter:description', '¿Tu hijo se niega a probar verduras? Con nuestras recetas, vas a ver platos vacíos y escuchar "¡Quiero más!" en solo 15 minutos.');
    setMetaName('twitter:image', 'https://cdn.magicpatterns.com/uploads/rueyTBTWirX8tFBqKabGa7/chicosllorandoheylloyd-image-1771674483003.png');
    // General meta description
    setMetaName('description', '¿Tu hijo se niega a probar verduras? Recetas rápidas con verduras invisibles. 65% OFF + 5 bonos gratis. Garantía de 60 días.');
  }, []);
  return <div className="min-h-screen font-sans text-gray-900 bg-[#FEE9D0]" data-id="element-402">
      <nav className="absolute top-0 left-0 w-full pt-4 pb-3 px-6 z-50" data-id="element-403">
        <div className="container mx-auto flex justify-between items-center" data-id="element-404">
          <div className="font-heading font-extrabold text-2xl text-orange-600 flex items-center gap-2" data-id="element-405">
            <img src="https://cdn.magicpatterns.com/uploads/cKDTNUcYJHYBaLM9bkArox/6.png" alt="Cocina Simple Ya logo" className="h-10 w-10 object-contain" style={{
            mixBlendMode: 'multiply'
          }} data-id="element-406" />
            Cocina Simple YA!
          </div>
        </div>
      </nav>

      <main data-id="element-407">
        <HeroSection data-id="element-408" />
        <SituationsSection data-id="element-409" />
        <PainSection data-id="element-410" />
        <SolutionSection data-id="element-411" />
        <CharactersSection data-id="element-412" />
        <MechanismSection data-id="element-413" />
        <FeaturesSection data-id="element-414" />
        <PricingSection data-id="element-415" />
        <GuaranteeSection data-id="element-416" />
        <PackSection data-id="element-417" />
        <BenefitsSection data-id="element-418" />
        <TestimonialsSection data-id="element-419" />
        <FAQSection data-id="element-420" />
        <ImaginateSection data-id="element-421" />
        <CTASection data-id="element-422" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-423">
        <div className="container mx-auto px-4" data-id="element-424">
          <p className="mb-4" data-id="element-425">
            &copy; 2024 Cocina Simple Ya!. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-426">
            <a href="#" className="hover:text-white transition-colors" data-id="element-427">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-428">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-429">
              Contacto
            </a>
          </div>
        </div>
      </footer>
    </div>;
}